module.exports = __webpack_public_path__ + "static/media/logo5.43db9949.png";